@if (iconType() === 'snackbar-export' || iconType() === 'snackbar-delete' || iconType() === 'snackbar-download') {
  <span class="cde-toast-icon toast-snackbar-icon">
    <claas-icon
      class="check-icon"
      [removeDefaultColor]="true"
      [iconName]="
        iconType() === 'snackbar-export'
          ? 'export'
          : iconType() === 'snackbar-delete'
            ? 'paper_bin_648544'
            : iconType() === 'snackbar-download'
              ? 'download_659464'
              : ''
      "
      [iconStyle]="'bold'"
      namespace="cc"
      [size]="24">
    </claas-icon>
  </span>
}
@if (iconType() === 'snackbar-success' || iconType() === 'snackbar-large') {
  <span class="cde-toast-icon toast-snackbar-success-icon">
    <claas-icon class="check-icon" iconId="000964" namespace="cc" [size]="20"> </claas-icon>
  </span>
}
@if (iconType() === 'snackbar-error') {
  <span class="cde-toast-icon toast-snackbar-error-icon">!</span>
}
@if (iconType() === 'snackbar-warning') {
  <span class="cde-toast-icon toast-snackbar-warning-icon"> </span>
}
